var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"message"},[_c('p',[_vm._v("無使用權限, ")]),_c('p',[_vm._v("如有疑問請聯系管理員")])])])
}]

export { render, staticRenderFns }